export const techData = {
  malaysia: {
    plugs: "Type G (UK three-pin)",
    voltage: "240V / 50Hz",
    usDevices: "Phones, laptops and most chargers are dual-voltage — just add a US-to-G plug adapter. 110V-only hair tools will fry; buy local.",
    power: "Reliable in cities; brief storm outages happen during monsoon season.",
    internet: "Excellent and cheap — 100–500 Mbps home fiber is normal (~$25–40/mo). Great for remote work.",
    tip: "Grab a 4-pack of US-to-G adapters on Amazon before you fly; local ones cost triple at the airport.",
  },
  uae: {
    plugs: "Type G (UK three-pin)",
    voltage: "230V / 50Hz",
    usDevices: "Dual-voltage chargers work with a plug adapter. Leave US hair dryers and kitchen gadgets — buy 230V locally.",
    power: "Rock solid; outages are essentially unheard of.",
    internet: "Fast fiber and 5G everywhere (~$80–100/mo home). Note: some VoIP/video-call apps are restricted — WhatsApp calls can be patchy; alternatives like Botim are common.",
    tip: "Set up your family's calling app situation BEFORE you land so the first call home isn't a troubleshooting session.",
  },
  egypt: {
    plugs: "Type C & F (European two-pin)",
    voltage: "220V / 50Hz",
    usDevices: "US-to-EU adapters are cheap and everywhere. Check every charger for '100–240V' — if it says that, you're fine.",
    power: "Mostly stable in Cairo's expat districts; occasional brief cuts in summer peak. Older buildings have quirky wiring — surge protectors are your friend.",
    internet: "Decent home DSL/fiber (50–100 Mbps, ~$10–20/mo) but speeds dip at peak hours. Mobile data is cheap and a good backup.",
    tip: "Pack two surge-protector power strips — they protect US electronics and multiply your outlets.",
  },
  morocco: {
    plugs: "Type C & E (European two-pin)",
    voltage: "220V / 50Hz",
    usDevices: "Dual-voltage devices + a US-to-EU adapter and you're set. Don't bring 110V-only appliances.",
    power: "Reliable in cities; rare brief outages. Older medina riads may need wiring patience.",
    internet: "Good fiber in cities (100+ Mbps, ~$25/mo). 4G backup is cheap and solid.",
    tip: "Inwi/Maroc Telecom tourist SIMs at the airport give you data in minutes — grab one on arrival day.",
  },
  indonesia: {
    plugs: "Type C & F (European two-pin)",
    voltage: "230V / 50Hz",
    usDevices: "US-to-EU adapters needed; most chargers are dual-voltage. Buy local 230V appliances.",
    power: "Stable in Jakarta and major cities; occasional cuts elsewhere, and island areas plan outages. A small UPS keeps the Wi-Fi alive.",
    internet: "Good fiber in cities (50–100 Mbps, ~$20–30/mo). Mobile data is famously cheap and reliable.",
    tip: "Telkomsel SIMs are the gold standard — get one at the airport with a big data package.",
  },
  saudi: {
    plugs: "Type G (UK three-pin) — older buildings may also have US-style A/B",
    voltage: "230V / 50Hz (some older homes 127V)",
    usDevices: "Mostly plug adapters needed; in older housing, double-check the outlet voltage before plugging anything precious.",
    power: "Very reliable in major cities.",
    internet: "Excellent fiber and 5G (~$60–80/mo). Some calling apps restricted — test yours early.",
    tip: "The mixed-voltage legacy is real: a cheap voltage tester pen in your travel kit saves electronics.",
  },
  turkiye: {
    plugs: "Type C & F (European two-pin)",
    voltage: "230V / 50Hz",
    usDevices: "US-to-EU adapters; dual-voltage chargers are fine. Leave 110V-only gadgets home.",
    power: "Reliable in cities; rare brief cuts. Old buildings can have eccentric wiring — surge protectors recommended.",
    internet: "Good fiber (100+ Mbps, ~$10–15/mo — some of the cheapest decent internet on this list).",
    tip: "Turkcell or Türk Telekom SIM on day one; eSIMs work well for the first weeks while paperwork settles.",
  },
  qatar: {
    plugs: "Type G (UK three-pin)",
    voltage: "240V / 50Hz",
    usDevices: "Plug adapters for everything; dual-voltage chargers fine. Buy local small appliances.",
    power: "Extremely reliable — world-class grid.",
    internet: "Fast fiber and 5G (~$80/mo). Same VoIP quirks as UAE — WhatsApp calling can be limited.",
    tip: "Ooredoo/Vodafone SIMs at the airport in 10 minutes; home fiber installs are quick.",
  },
  oman: {
    plugs: "Type G (UK three-pin)",
    voltage: "240V / 50Hz",
    usDevices: "Plug adapters + dual-voltage chargers; leave 110V-only tools behind.",
    power: "Reliable in Muscat; brief cuts possible in small towns and during khareef storms in Salalah.",
    internet: "Good fiber in Muscat (~$50–70/mo), mobile 4G/5G solid on the coast.",
    tip: "Omantel or Ooredoo SIM on arrival; coverage on mountain and desert trips is surprisingly good.",
  },
  jordan: {
    plugs: "Type C, F & G (European and UK — mixed!)",
    voltage: "230V / 50Hz",
    usDevices: "Bring a UNIVERSAL adapter for Jordan — you'll meet both EU and UK sockets, sometimes in the same apartment.",
    power: "Generally stable in Amman; winter storms occasionally knock lines down briefly.",
    internet: "Decent fiber in Amman (50–200 Mbps, ~$25–40/mo); mobile data cheap and dependable.",
    tip: "The universal adapter is the move here — Jordan's mixed sockets surprise everyone once.",
  },
  tanzania: {
    plugs: "Type D & G (old British three-pin and UK three-pin)",
    voltage: "230V / 50Hz",
    usDevices: "Universal adapter needed (D and G sockets both appear). Dual-voltage chargers fine; surge protection strongly advised.",
    power: "The honest one: outages happen, sometimes daily in stretches. Families keep torches, power banks, and a small inverter or UPS for Wi-Fi.",
    internet: "Improving fast — fiber exists in Dar/Zanzibar towns (~$30–50/mo); 4G mobile data is the reliable backbone.",
    tip: "Power banks for everyone, a charged lantern per room, and download offline maps + Quran apps before travel days.",
  },
};

export const simData = {
  malaysia: {
    availability: "Easy",
    availabilityNote: "Tourist SIMs sold at every airport kiosk, 7-Eleven, and mall booth with just your passport — about $8–$15 for 15–30GB. Residents register a postpaid or long-term prepaid line with passport + visa/MM2H or DE Rantau card.",
    carriers: ["Maxis / Hotlink", "CelcomDigi", "U Mobile"],
    esim: "Airalo & Holafly eSIMs work fine for week one; a local tourist SIM at KLIA is cheaper for longer.",
    home: "Time or Unifi fiber — 100–500 Mbps installs within days.",
  },
  uae: {
    availability: "Easy with ID",
    availabilityNote: "Free tourist SIM at Dubai/Abu Dhabi airport immigration for visitors (limited data; top-ups ~$15–$30). A full monthly line needs your Emirates ID once residency is issued — expect ~$25–$50/month. Only e& and du sell SIMs; kiosks are everywhere.",
    carriers: ["e& (Etisalat)", "du"],
    esim: "e& tourist eSIM at the airport is the fastest start; bring an unlocked phone.",
    home: "e& or du fiber, often bundled with TV — ask for the internet-only deal.",
  },
  egypt: {
    availability: "Easy",
    availabilityNote: "Passport-registered tourist SIMs at airport kiosks and any carrier shop for ~$5–$10 with 10–20GB. Tourist lines expire after ~90 days; convert to a resident line with your residency card. Bring your own unlocked phone — imported phones now face an import fee after ~90 days.",
    carriers: ["Vodafone Egypt", "Orange", "e& (Etisalat)", "WE"],
    esim: "Skip eSIM markups — Vodafone kiosk at Cairo airport sets you up in 15 minutes with passport.",
    home: "WE or Vodafone home internet, plus a 4G router as peak-hour backup.",
  },
  morocco: {
    availability: "Very easy",
    availabilityNote: "SIMs are handed out nearly free at airports and sold at every tabac shop for ~$2–$5; passport registration is quick. Data bundles ~$10 for 20GB. No residency needed for prepaid; postpaid needs your carte de séjour.",
    carriers: ["Maroc Telecom", "Orange MA", "inwi"],
    esim: "inwi offers easy eSIM; airport SIMs cost a few dollars with generous data.",
    home: "Maroc Telecom fiber in the cities; 4G box elsewhere.",
  },
  indonesia: {
    availability: "Easy with passport",
    availabilityNote: "Tourist SIMs at airports and mall kiosks (~$10–$20 for 20–40GB) require passport registration; foreign phones must be IMEI-registered at customs to work past 90 days (tax applies above ~$500 phone value). Residents register with KITAS + NPWP.",
    carriers: ["Telkomsel (best coverage)", "XL Axiata", "Indosat"],
    esim: "Telkomsel tourist eSIM — passport registration is required for any local SIM.",
    home: "IndiHome fiber in cities; mobile data carries you elsewhere.",
  },
  saudi: {
    availability: "Easy with ID",
    availabilityNote: "Tourist SIMs at airports and carrier shops register against your passport + visa (~$15–$30 for 20–50GB). Residents need an Iqama for a regular line; lines are capped per ID. Absher app manages everything once you have an Iqama.",
    carriers: ["STC", "Mobily", "Zain"],
    esim: "STC tourist eSIM at the airport; all SIMs register against your ID/visa.",
    home: "STC fiber is the default and it's fast.",
  },
  turkiye: {
    availability: "Easy, with a catch",
    availabilityNote: "Tourist SIMs at airport counters and carrier shops with passport (~$20–$40 for 20–30GB — tourist pricing is high). Residents get cheaper plans with an ikamet. Critical: foreign phones stop working after 120 days unless you pay the IMEI registration tax (~$900+), so long-stayers buy a local phone.",
    carriers: ["Turkcell", "Türk Telekom", "Vodafone TR"],
    esim: "Turkcell tourist eSIM is easy — but note: a foreign phone used 120+ days in Turkey gets blocked unless you pay the hefty IMEI registration tax. Long-stayers often buy a local phone.",
    home: "Türk Telekom or Turkcell Superonline fiber — cheap and quick to install.",
  },
  qatar: {
    availability: "Easy with ID",
    availabilityNote: "Visitor SIMs at Hamad airport with passport (~$15–$25). Residents need a Qatar ID (QID) for a full line; only Ooredoo and Vodafone operate. Coverage is excellent everywhere.",
    carriers: ["Ooredoo", "Vodafone Qatar"],
    esim: "Ooredoo visitor eSIM at Hamad airport, 10 minutes.",
    home: "Ooredoo fiber — often included in compound rents, ask before signing a lease.",
  },
  oman: {
    availability: "Easy",
    availabilityNote: "Tourist SIMs at Muscat airport and carrier shops with passport (~$10–$20). Residents register with their resident card. Prepaid data is generous and cheap; 5G in Muscat.",
    carriers: ["Omantel", "Ooredoo Oman", "Vodafone Oman"],
    esim: "Omantel tourist SIM at Muscat airport; straightforward passport registration.",
    home: "Omantel fiber in Muscat; mobile data elsewhere.",
  },
  jordan: {
    availability: "Easy",
    availabilityNote: "SIMs at Queen Alia airport and any shop with passport (~$7–$15 with 10–20GB). Tourist lines can be renewed monthly; postpaid needs a residency card. Jordan also charges a small tax on SIMs and data.",
    carriers: ["Zain", "Orange Jordan", "Umniah"],
    esim: "Zain visitor line at Queen Alia airport — cheap monthly bundles.",
    home: "Orange or Zain fiber in Amman; 4G router as backup in winter storms.",
  },
  tanzania: {
    availability: "Easy with passport",
    availabilityNote: "Prepaid SIMs at airports, carrier shops, and street agents (~$1–$3 SIM, ~$5–$10 monthly data bundles). Passport registration plus a fingerprint/photo is mandatory. Zanzibar and mainland use the same carriers; mobile money (M-Pesa) runs daily life.",
    carriers: ["Vodacom", "Airtel", "Tigo"],
    esim: "Tourist SIM with passport registration at the airport or town shops — data bundles are affordable.",
    home: "Fiber where it exists (Dar, Zanzibar town); honestly, a 4G router is the real backbone here.",
  },
};
